export default __webpack_public_path__ + "assets/glyphicons-halflings-regular.5be1347c682810f199c7f486f40c5974.eot";